module.exports = __webpack_public_path__ + "img/standardGZDPYL.e44326e8.png";